import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  justify-content: center;
  align-items: center;
`

export const ErrorScreen: React.FC<{
  title: string
  message: string
  className?: string
  children?: React.ReactNode
}> = ({ title, message, className, children }) => {
  return (
    <Container className={className}>
      <h1>{title}</h1>
      <h3>{message}</h3>
      {!children ? null : <br />}
      {children}
    </Container>
  )
}
